/**
 * App-icon unread badge sync.
 * - Native (iOS/Android via Capacitor): @capawesome/capacitor-badge plugin.
 *   NOTE: takes effect on devices only after a native rebuild (`npx cap sync`).
 * - Web / installed PWA fallback: navigator.setAppBadge / clearAppBadge.
 * Every call is best-effort — it must NEVER break the app when unsupported.
 */
let nativePermissionAsked = false;
let lastSet = null;

export async function updateAppBadge(count) {
  const n = Math.max(0, Number(count) || 0);
  if (n === lastSet) return; // avoid redundant plugin calls
  try {
    const Cap = window.Capacitor;
    if (Cap && Cap.isNativePlatform && Cap.isNativePlatform()) {
      const { Badge } = await import("@capawesome/capacitor-badge");
      try {
        const { isSupported } = await Badge.isSupported();
        if (!isSupported) return;
      } catch (e) {
        return; // plugin not present in this native build yet
      }
      if (!nativePermissionAsked) {
        nativePermissionAsked = true;
        try {
          const perm = await Badge.checkPermissions();
          if (perm.display === "prompt" || perm.display === "prompt-with-rationale") {
            await Badge.requestPermissions();
          }
        } catch (e) { /* permission APIs are optional on some platforms */ }
      }
      if (n > 0) await Badge.set({ count: n });
      else await Badge.clear();
      lastSet = n;
      return;
    }
    // Web / installed PWA (Chrome, Edge, Safari 17+)
    if (typeof navigator !== "undefined" && "setAppBadge" in navigator) {
      if (n > 0) await navigator.setAppBadge(n);
      else if ("clearAppBadge" in navigator) await navigator.clearAppBadge();
      lastSet = n;
    }
  } catch (e) {
    /* badge is best-effort — swallow every error */
  }
}
